import { render, staticRenderFns } from "./GiftCards.vue?vue&type=template&id=6083dbc2&scoped=true&"
import script from "./GiftCards.vue?vue&type=script&lang=ts&"
export * from "./GiftCards.vue?vue&type=script&lang=ts&"
import style0 from "./GiftCards.vue?vue&type=style&index=0&id=6083dbc2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6083dbc2",
  null
  
)

export default component.exports